import * as Actions from '../../actions/auth/type';

const auth = (state = {}, action) => {
  switch (action.type) {
    case Actions.USER_LOGIN_REQUEST:
      return { ...state, loading: true };
    case Actions.USER_LOGIN_SUCCESS:
      return {
        ...state,
        loading: true,
        userData: action.payload,
        success: true,
      };
    case Actions.USER_LOGIN_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.USER_LOGOUT:
      return {};
    case Actions.USER_CONFIRM_REQUEST:
      return { loading: true };
    case Actions.USER_CONFIRM_SUCCESS:
      return { loading: false, confirmEmailSuccess: true };
    case Actions.USER_CONFIRM_FAIL:
      return { loading: false, confirmEmailError: true };
    case Actions.MECHANIC_EMAIL_REQUEST:
      return { loading: true };
    case Actions.MECHANIC_EMAIL_SUCCESS:
      return {
        loading: false,
        mechanicEmailVerified: 1,
        ...action.payload,
      };
    case Actions.MECAHNIC_EMAIL_FAIL:
      return {
        loading: false,
        mechanicEmailVerified: 0,
        error: action.payload,
      };

    case Actions.USER_FORGOT_REQUEST:
      return { loading: true };
    case Actions.USER_FORGOT_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotPassword: action.payload,
        success: true,
      };
    case Actions.USER_FORGOT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case Actions.USER_RESET_PASSWORD_REQUEST:
      return { loading: true };
    case Actions.USER_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        resetUser: action.payload,
        success: true,
      };
    case Actions.USER_RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case Actions.CLEAR_RESET_PASSWORD_STATE:
      return {
        ...state,
        success: false,
        error: '',
      };

    case Actions.CLEAR_MECHANIC_EMAIL:
      return {
        ...state,
        mechanicEmailVerified: 0,
      };
    default:
      return state;
  }
};
export default auth;
